import React from 'react';
import { Button } from '@mui/material';

import * as S from './styles';

interface Props {
  title: string;
  buttonTitle?: string;
  isButtonDisabled?: boolean;
  onButtonClick?: () => void;
}

const MainContentHeader = ({ title, buttonTitle, isButtonDisabled, onButtonClick }: Props) => {
  return (
    <S.Wrap>
      <S.PageTitle>{title}</S.PageTitle>
      <Button variant='contained' onClick={onButtonClick} size='large' disabled={isButtonDisabled}>{buttonTitle}</Button>
    </S.Wrap>
  );
};

export default MainContentHeader;
